import assignments from './assignments/reducer';
import errors from './errors/reducer';
import { combineReducers } from 'redux';

export default combineReducers({
  assignments,
  errors,
});
